import React from "react";

const ComparisonProductLabel = ({product, translations}) => {
    return (
        <div className={"product-label" + (product.inCart ? " in-cart": "")}>
            {product.thumbnailUrl && (
                <img className="product-label-thumbnail" src={product.thumbnailUrl}/>
            )}
            {product.internal && (
                <div className="u2d-internal-part">
                    {translations["internal-part"]}
                </div>
            )}
            <div className="product-label-title">
                <a href={Liferay.ThemeDisplay.getPortalURL() + product.detailsUrl}>{product.id}</a>
            </div>
        </div>
    )
}

export default ComparisonProductLabel;